import React from 'react';

// A simple finance/money SVG icon for KPI cards
const FinanceIcon = ({ style = {}, className = "" }) => (
  <svg
    viewBox="0 0 1024 1024"
    focusable="false"
    data-icon="finance"
    width="1em"
    height="1em"
    fill="currentColor"
    aria-hidden="true"
    style={style}
    className={className}
  >
    {/* Coin stack */}
    <ellipse cx="512" cy="800" rx="240" ry="80" fill="#e6e6e6" />
    <ellipse cx="512" cy="720" rx="200" ry="60" fill="#bfbfbf" />
    <ellipse cx="512" cy="640" rx="160" ry="40" fill="#8c8c8c" />
    {/* Dollar sign */}
    <path d="M512 320c-44 0-80 36-80 80s36 80 80 80 80-36 80-80-36-80-80-80zm0 120c-22 0-40-18-40-40s18-40 40-40 40 18 40 40-18 40-40 40z" fill="#52c41a" />
    <rect x="496" y="200" width="32" height="240" rx="16" fill="#52c41a" />
    <rect x="496" y="400" width="32" height="240" rx="16" fill="#52c41a" />
  </svg>
);

export default FinanceIcon;
